enum code {
  AUTH_DUPLICATED_JOBRAINBOW = 'E001001',
  AUTH_DUPLICATED_TWITTER = 'E001002',
  AUTH_DUPLICATED_GOOGLE = 'E001003',
}

export default code
